import React from 'react'
import createSvgIcon from 'client/icons/createSvgIcon'

export default createSvgIcon(
  <path d="M19 9V7c0-2.2-1.8-4-4-4H9C6.8 3 5 4.8 5 7v2c-1.7 0-3 1.3-3 3v4c0 1.7 1.3 3 3 3v1c0 .6.4 1 1 1s1-.4 1-1v-1h10v1c0 .6.4 1 1 1s1-.4 1-1v-1c1.7 0 3-1.3 3-3v-4c0-1.7-1.3-3-3-3zM7 7c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v2.8c-.6.5-1 1.3-1 2.2v1H8v-1c0-.9-.4-1.7-1-2.2V7zm13 9c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1v-4c0-.6.4-1 1-1s1 .4 1 1v2c0 .6.4 1 1 1h10c.6 0 1-.4 1-1v-2c0-.6.4-1 1-1s1 .4 1 1v4z" />,
  'SofaBed'
)
